import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { selectorVariablesMomentsEditades } from '../../selectors/selector_estacio_formulari_dades';
import EstacioVariables from './estacioVariables';

class EstacioIntroduccioVariables extends Component {
    render() {
        const { dades } = this.props;

        return <EstacioVariables editable={true} dades={dades}/>;
    }
}

EstacioIntroduccioVariables.propTypes = {
    dades: PropTypes.array
};

const mapStateToProps = (state) => {
    return {
        dades: selectorVariablesMomentsEditades(state)
    };
};
const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(EstacioIntroduccioVariables);



// WEBPACK FOOTER //
// ./src/components/estacio/estacioIntroduccioVariables.js